import './css/custom.scss'

import 'jquery'
window.$ = $;

import 'bootstrap'

import './js/logoSizer'
import './js/kampagne1'
import './js/kampagne2'